import axios from 'axios'
import router from '../router'
import { ElMessage } from 'element-plus'

//axios实例
const ystHttpRequest = axios.create({
	//  development开发模式 production生产模式
	baseURL: process.env.NODE_ENV === 'development' ? '/AdminApi' : '/ystms',
	// baseURL: 'https://yunshiplay.com/ystms',
	timeout: 8000 //默认超时时间
})

// 添加请求拦截器
ystHttpRequest.interceptors.request.use(
	config => config,
	err => Promise.reject(err)
)

// 添加响应拦截器
ystHttpRequest.interceptors.response.use(
	response => response,
	err => {
		if (err && err.response) {
			switch (err.response.status) {
				case 400:
					ElMessage.error('Error request.')
					break
				// case 401:
				// 	ElMessage.error('Unauthorized, please log in again.')
				// 	break
				case 403:
					ElMessage.error('Access denied.')
					break
				case 404:
					ElMessage.error('Request error, the resource was not found.')
					break
				case 405:
					ElMessage.error('Request method not allowed.')
					break
				case 408:
					ElMessage.error('Request timeout.')
					break
				case 500:
					ElMessage.error('Server side error.')
					break
				case 501:
					ElMessage.error('Network not implemented.')
					break
				case 502:
					ElMessage.error('Network error.')
					break
				case 503:
					ElMessage.error('Service Unavailable.')
					break
				case 504:
					ElMessage.error('Network Timeout.')
					break
				case 505:
					ElMessage.error('The HTTP version does not support the request.')
					break
				default:
					ElMessage.error(`Connection error${err.response.status}.`)
			}
		} else if (err && err.__CANCEL__) {
			ElMessage.error('Request cancelled.')
		} else {
			ElMessage.error('Failed to connect to the server.')
		}
		return Promise.reject(err.response)
	}
)

// axios请求封装
export const request = ({
  url, //接口路径
  data = {}, //POST参数
  params = {}, //GET参数
  headers = {  //请求头
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  method = 'GET', //请求类型
  timeout = 8000, //超时时间
  isLoading = false, //是否显示加载动画
  needToken = true, //是否需要token
  loadingText, //加载动画文字
  cancelToken, //取消请求
  responseType = 'json', //响应参数类型
  needYstms = true, //响应参数类型
  onUploadProgress //上传进度函数
}:any) => {
  return new Promise((resolve, reject) => {
	  if(needToken) headers.Authorization = 'web eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJzZW5rZWRpYW56aSIsImp0aSI6IjI1NmY0MWUzLTNhZjMtNDM0OS04MjVmLWJkMTBlNWU5ODc2MyIsImlhdCI6MTcwNDU1NDIyMywic3ViIjoid3poIiwiZXhwIjoxNzA0NTgzMDIzfQ._CsHT8dtiCh3XLiTQaA4bZWaBzn1XfZp0wHILWd3yKBX4VwQcjGXKAYBdY9ChSWyfX-c8fh36q8ByiyiXpIwiA'
    ystHttpRequest({
      url,
      data,
      params,
      headers,
      method,
      timeout,
      cancelToken,
      responseType,
      onUploadProgress
    }).then(res => {
      const { code, message } = res.data
      if (code !== 200 && code!== -10001 && code!== 401 && code) ElMessage.error(message) //请求错误时的提示,-20000为特定错误，需要根据具体情况特殊处理
      if (responseType === 'arraybuffer') resolve(res)
      else resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}